import clsx from "clsx";
import { ReactNode } from "react";

export const LegendBlock = ({ children, className }: { children: ReactNode; className?: string }) => {
    return <ul className={clsx("ant-sm flex flex-wrap items-center gap-ant-lg", className)}>{children}</ul>;
};

export const LegendItem = ({ picto, legend, className }: { picto: ReactNode; legend: string; className?: string }) => {
    return (
        <li className={clsx("flex items-center gap-ant-xxs", className)}>
            {picto} <span>{legend}</span>
        </li>
    );
};
